import React, { Suspense, lazy } from "react";

const ReactQuill = lazy(() =>
  Promise.all([
    import("react-quill"),
    import("react-quill/dist/quill.snow.css"),
  ]).then(([module]) => ({ default: module.default }))
);

const editorFallback = (
  <div
    aria-hidden="true"
    style={{
      minHeight: 220,
      border: "1px solid #d9d9d9",
      borderRadius: 8,
      background: "#fff",
    }}
  />
);

const Editor = ({ value, onChange }) => (
  <Suspense fallback={editorFallback}>
    <ReactQuill theme="snow" value={value} onChange={onChange} />
  </Suspense>
);

export default Editor;
